module.exports = __webpack_public_path__ + "img/DE01338.9d976cea.png";